<template>
  <div class="auth-submit-container">
    <HeadProcess active="1" />
    <div class="spacing"></div>
    <div class="content">
      <p v-if="isAuthenticated" class="hint-success">
        <img src="@/assets/imgs/ic_result_pass@2x.png" alt="" />
        <span> 已通过企业认证</span>
      </p>
      <!-- 企业名称：canEdit 时可搜索选择，否则只读回显 -->
      <div class="item-input-box item-input-box-first">
        <p class="title">
          <span> 企业名称<span style="color:#F15643">*</span> </span>
        </p>
        <van-field
          v-model="queryName"
          center
          clearable
          maxlength="24"
          :disabled="!canEdit"
          placeholder="请输入企业名称搜索"
          @input="remoteMethod"
          @keyup.enter.native="handleEnterSearch"
        >
          <template #button v-if="canEdit">
            <van-button
              class="searchBtn"
              size="small"
              type="primary"
              :loading="getCompanyListLoading"
              @click="handleEnterSearch"
            >
              查询
            </van-button>
          </template>
        </van-field>
        <ul class="list" v-if="canEdit && companyList.length > 0">
          <li
            v-for="(item, index) in companyList"
            :key="index"
            @click="handleRow(item)"
          >
            <div class="name" v-html="item.html">{{ item.comName }}</div>
            <div class="tag">工商注册名称</div>
          </li>
        </ul>
      </div>
      <div class="item-input-box">
        <p class="title">
          <span> 社会统一信用代码<span style="color:#F15643">*</span> </span>
        </p>
        <van-field
          v-model="userAuthInfo.comCreditCode"
          :border="true"
          :disabled="!canEdit"
          placeholder="输入统一社会信用代码/工商注册号"
        />
      </div>
      <div class="item-input-box">
        <p class="title">
          <span> 法定代表人<span style="color:#F15643">*</span> </span>
        </p>
        <van-field
          v-model="userAuthInfo.comLegalName"
          :border="true"
          :disabled="!canEdit"
          placeholder="输入法定代表人姓名"
        />
      </div>
      <div class="item-input-box">
        <p class="title">
          <span> 法人身份证号<span style="color:#F15643">*</span> </span>
        </p>
        <van-field
          v-model="legalRepIdCardNo"
          :border="true"
          maxlength="18"
          placeholder="请输入法定代表人身份证号"
          @input="onIdInput"
        />
        <div class="form-hint">
          请填写法定代表人本人 18 位身份证号，提交后不可修改
        </div>
      </div>

      <!-- 法人身份核验 -->
      <div class="section-title">法人身份核验</div>
      <div class="auth-alert">
        重要提醒：采用「法人在线认证」方式后，系统将默认认定本人为本企业唯一经办人，未来平台内公司所有合同、文件的盖章操作都需要经办人完成。
      </div>
      <div class="item-input-box">
        <p class="title">
          <span> 法人手机号<span style="color:#F15643">*</span> </span>
        </p>
        <van-field
          v-model="legalRepMobile"
          :border="true"
          type="digit"
          maxlength="11"
          placeholder="请输入法定代表人本人手机号"
          @input="onPhoneInput"
        />
        <div class="form-hint">
          用于法人在线认证时的短信验证码，请确保是法定代表人本人常用手机号
        </div>
      </div>

      <!-- 营业执照 -->
      <div class="item-input-box">
        <p class="title">
          <span> 企业营业执照<span style="color:#F15643">*</span> </span>
        </p>
        <van-uploader
          :max-count="1"
          :max-size="10 * 1024 * 1024"
          accept="image/jpeg,image/png,.pdf"
          :after-read="file => afterRead(file, 'businessLicense')"
          @oversize="onOversize('文件大小不能超过 10M')"
        >
          <div class="upload-box" v-if="!uploads.businessLicense.fileUrl">
            <van-icon name="photo-o" />
            <span>上传营业执照</span>
          </div>
          <div class="upload-file" v-else>
            <img
              v-if="!uploads.businessLicense.isPdf"
              :src="uploads.businessLicense.fileUrl"
              alt="预览"
            />
            <div v-else class="pdf-file">
              <van-icon name="description" />
              <span>PDF</span>
            </div>
          </div>
        </van-uploader>
        <div class="form-hint">
          支持 jpg、png、pdf 格式，文件大小不超过 10M，需清晰可辨认
        </div>
      </div>

      <!-- 法人身份证 -->
      <div class="item-input-box">
        <p class="title">
          <span> 身份证照片<span style="color:#F15643">*</span> </span>
        </p>
        <div class="id-card-area">
          <van-uploader
            :max-count="1"
            :max-size="10 * 1024 * 1024"
            accept="image/jpeg,image/png"
            :after-read="file => afterRead(file, 'legalIdFront')"
            @oversize="onOversize('文件大小不能超过 10M')"
          >
            <div class="upload-box" v-if="!uploads.legalIdFront.fileUrl">
              <van-icon name="photo-o" />
              <span>人像面</span>
            </div>
            <div class="upload-file" v-else>
              <img :src="uploads.legalIdFront.fileUrl" alt="预览" />
            </div>
          </van-uploader>
          <van-uploader
            :max-count="1"
            :max-size="10 * 1024 * 1024"
            accept="image/jpeg,image/png"
            :after-read="file => afterRead(file, 'legalIdBack')"
            @oversize="onOversize('文件大小不能超过 10M')"
          >
            <div class="upload-box" v-if="!uploads.legalIdBack.fileUrl">
              <van-icon name="photo-o" />
              <span>国徽面</span>
            </div>
            <div class="upload-file" v-else>
              <img :src="uploads.legalIdBack.fileUrl" alt="预览" />
            </div>
          </van-uploader>
        </div>
        <div class="form-hint">
          请确保照片四角完整、字迹清晰、人像面与国徽面信息与法定代表人一致
        </div>
      </div>
    </div>
    <div class="button-box">
      <van-button plain type="info" @click="handleBack">取消</van-button>
      <van-button
        v-if="!isAuthenticated"
        type="info"
        :loading="submitLoading"
        @click="handleSubmit"
        >提交</van-button
      >
    </div>
  </div>
</template>

<script>
  import creditApis from '@/api/creadit'
  import caApi from '@/api/ca'
  import Apifiles from '@/api/files'
  import { mapState } from 'vuex'
  import { Toast } from 'vant'
  import {
    validateIdentityNumber,
    validateMobileNumber,
  } from '@/utils/validate'
  import HeadProcess from './Components/headProcess.vue'

  // 简单的防抖函数实现
  function debounce(fn, delay) {
    let timer = null
    return function debounced(...args) {
      if (timer) clearTimeout(timer)
      timer = setTimeout(() => {
        fn.apply(this, args)
      }, delay)
    }
  }

  export default {
    components: {
      HeadProcess,
    },
    data() {
      return {
        // 授权信息（来自 getComAuthInfo 回显）
        userAuthInfo: {
          comName: '',
          comCreditCode: '',
          comLegalName: '',
        },
        // 法人手机号、身份证号（不放在 userAuthInfo，便于输入清洗）
        legalRepMobile: '',
        legalRepIdCardNo: '',
        // 认证方式：固定为法人在线认证
        verifyMethod: 'LEGAL',
        // 上传文件：{ fileKey, fileUrl, isPdf }
        uploads: {
          businessLicense: {},
          legalIdFront: {},
          legalIdBack: {},
        },
        // 企业搜索
        companyList: [],
        queryName: '',
        getCompanyListLoading: false,
        // 提交 loading
        submitLoading: false,
        // 企业 CA 认证状态（来自 getCaStatus：0=未认证，非0=已认证）
        comCaStatus: 0,
        comId: null,
      }
    },
    async created() {
      if (this.$route.query.comId) {
        this.comId = this.$route.query.comId || null
      }
      // 创建防抖版本的搜索方法（300ms 防抖）
      this.debouncedGetCompanyList = debounce(this.getCompanyList, 300)
      // 先取认证状态（控制按钮/编辑），再回填企业信息
      await this.getCaAuthStatus()
      await this.getComAuthInfo()
    },
    computed: {
      ...mapState({
        userInfo: state => state.user.userInfo,
      }),
      // 已完成企业 CA 认证（comCaStatus 非0）
      isAuthenticated() {
        return this.comCaStatus !== 0
      },
      // 未认证时可编辑
      canEdit() {
        return this.comCaStatus !== 1 && this.userInfo.comCreditStatus !== 1
      },
    },

    methods: {
      // 获取企业认证信息（仅回填数据，状态以 getCaStatus 为准）
      getComAuthInfo() {
        return creditApis
          .getComAuthInfo({
            comId: this.comId || this.userInfo.comId,
          })
          .then(res => {
            this.userAuthInfo = {
              comName: res.comName || '',
              comCreditCode: res.comCreditCode || '',
              comLegalName: res.comLegalName || '',
            }
            // 已选择企业时同步搜索关键字
            this.queryName = res.comName || ''
          })
      },
      // 获取企业 CA 认证状态（0=未认证，非0=已认证）
      async getCaAuthStatus() {
        try {
          const res = await caApi.getCaStatus()
          this.comCaStatus = res.comCaStatus
        } catch (e) {
          console.error('getCaStatus failed', e)
        }
      },
      // 远程搜索企业（输入触发，3 字起步 + 防抖）
      remoteMethod(query) {
        if (query && query !== '') {
          if (query.length >= 3) {
            this.debouncedGetCompanyList()
          } else {
            this.companyList = []
          }
        } else {
          this.companyList = []
        }
      },
      // 回车键时忽略长度限制直接搜索
      handleEnterSearch() {
        if (this.queryName && this.queryName !== '') {
          this.getCompanyList()
        }
      },
      // 获取企业列表
      getCompanyList() {
        this.getCompanyListLoading = true
        return creditApis
          .getCompanyList({ keyword: this.queryName })
          .then(res => {
            res.rowsList.forEach(e => {
              e.html = e.comName
                .split(this.queryName)
                .join(
                  `<span style="color: #1676ff;">${this.queryName}</span>`
                )
            })
            this.companyList = res.rowsList
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {
            this.getCompanyListLoading = false
          })
      },
      // 选择企业后自动填充其他字段
      handleRow(row) {
        this.userAuthInfo = { ...this.userAuthInfo, ...row }
        this.queryName = row.comName
        this.companyList = []
      },
      // 输入清洗：身份证号（仅数字和 X，并大写）
      onIdInput(value) {
        this.legalRepIdCardNo = value.replace(/[^0-9Xx]/g, '').toUpperCase()
      },
      // 输入清洗：手机号（仅数字，截断 11 位）
      onPhoneInput(value) {
        this.legalRepMobile = value.replace(/[^0-9]/g, '').slice(0, 11)
      },
      // 上传读取：base64 → uploadNew → fileKey
      async afterRead(file, type) {
        const imgType = `.${file.file.name
          .split('.')
          .pop()
          .toLowerCase()}`
        const isPdf = imgType === '.pdf'
        if (!isPdf && !['.jpg', '.jpeg', '.png'].includes(imgType)) {
          Toast('仅支持 jpg、png 格式')
          return
        }
        Toast.loading({ message: '上传中', forbidClick: true, duration: 0 })
        try {
          const { fileKey } = await Apifiles.uploadNew({
            objectBase64: file.content,
            objectFormat: imgType,
          })
          this.uploads[type] = {
            fileKey,
            fileUrl: file.content,
            isPdf,
          }
        } catch (err) {
          Toast('上传失败，请重试')
          console.log(err)
        } finally {
          Toast.clear()
        }
      },
      onOversize(msg) {
        Toast(msg)
      },
      // 校验表单字段
      validateForm() {
        if (!this.userAuthInfo.comName) {
          return '请选择企业名称'
        }
        if (!this.userAuthInfo.comCreditCode) {
          return '请输入统一社会信用代码'
        }
        if (!this.userAuthInfo.comLegalName) {
          return '请输入企业法定代表人'
        }
        if (!this.legalRepIdCardNo) {
          return '请填写法人身份证号'
        }
        if (!validateIdentityNumber(this.legalRepIdCardNo)) {
          return '请输入正确的身份证号'
        }
        if (!this.legalRepMobile) {
          return '请输入法人手机号'
        }
        if (!validateMobileNumber(this.legalRepMobile)) {
          return '请输入正确的手机号'
        }
        return false
      },
      // 校验上传文件
      validateUploads() {
        if (!this.uploads.businessLicense.fileKey) {
          return '请上传企业营业执照'
        }
        if (
          !this.uploads.legalIdFront.fileKey ||
          !this.uploads.legalIdBack.fileKey
        ) {
          return '请上传法人身份证正、反面'
        }
        return false
      },
      // 构建提交参数（仅法人在线认证 LEGAL）
      buildSubmitModel() {
        const callBackUrl = `${window.location.origin}/authResult`
        return {
          corpType: 'company',
          corpFullName: this.userAuthInfo.comName,
          corpUnifiedIdentifier: this.userAuthInfo.comCreditCode,
          legalRepName: this.userAuthInfo.comLegalName,
          legalRepIdCardNo: this.legalRepIdCardNo,
          verifyMethod: this.verifyMethod,
          legalRepMobile: this.legalRepMobile,
          // 上传文件统一传 fileKey
          licenseUrl: this.uploads.businessLicense.fileKey,
          legalRepIdCardFront: this.uploads.legalIdFront.fileKey,
          legalRepIdCardBack: this.uploads.legalIdBack.fileKey,
          callBackUrl,
        }
      },
      // 提交认证信息（发起法人在线认证）
      async handleSubmit() {
        const errMsg = this.validateForm()
        if (errMsg) {
          Toast(errMsg)
          return
        }
        const uploadErr = this.validateUploads()
        if (uploadErr) {
          Toast(uploadErr)
          return
        }
        this.submitLoading = true
        try {
          const model = this.buildSubmitModel()
          const data = await caApi.applyCorpCaVerify(model)
          if (data && data.url) {
            // 跳第三方进行法人在线认证
            window.location.href = data.url
          } else {
            Toast('无有效地址')
          }
        } catch (error) {
          console.error(error)
        } finally {
          this.submitLoading = false
        }
      },

      // 返回
      handleBack() {
        this.$router.back()
      },
    },
  }
</script>

<style lang="less" scoped>
  .auth-submit-container {
    padding-bottom: 66px;
    .content {
      padding: 24px 16px 16px;
      position: relative;
      .list {
        height: calc(100vh - 310px);
        overflow-y: auto;
        li {
          height: 52px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 0.5px solid #eeeeee;
          .name {
            font-size: 15px;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            text-align: left;
            color: #111a34;
            line-height: 21px;
            letter-spacing: 0.26px;
            flex: 1;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            span {
              color: #1676ff;
            }
          }
          .tag {
            width: 95px;
            height: 21px;
            background: #f5f5f5;
            border-radius: 2px;
            font-size: 13px;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            text-align: center;
            color: #999999;
            line-height: 21px;
            letter-spacing: 0.22px;
          }
        }
      }
      .suc-mask {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }
      .hint-success,
      .hint-error {
        font-size: 14px;
        font-weight: 500;
        color: #16bb83;
        padding-bottom: 24px;
        img {
          width: 14px;
          height: 14px;
        }
      }
      .hint-error {
        color: #f15643;
      }
      .section-title {
        font-size: 15px;
        font-weight: 600;
        color: #1f2329;
        margin: 24px 0 12px;
        display: flex;
        align-items: center;

        &::before {
          content: '';
          display: inline-block;
          width: 3px;
          height: 14px;
          background: #1676ff;
          border-radius: 2px;
          margin-right: 8px;
        }
      }
      .auth-alert {
        font-size: 12px;
        color: #7a4e00;
        line-height: 1.6;
        background: #fff7e8;
        border: 1px solid #ffd980;
        border-radius: 6px;
        padding: 10px 12px;
        margin-bottom: 16px;
      }
      .form-hint {
        font-size: 12px;
        color: #8f959e;
        margin-top: 6px;
        line-height: 1.5;
      }
      .item-input-box {
        .searchBtn {
          font-size: 14px;
          width: 90px;
          height: 32px;
        }
        /deep/.van-field__control {
          color: #323233 !important;
        }
        .title {
          font-size: 14px;
          font-weight: 400;
          color: #111a34;
          line-height: 22px;
          padding: 0;
          display: flex;
          justify-content: space-between;
          margin: 20px 0 0 0;
        }
        .van-cell {
          padding: 0;
          display: flex;
          align-items: center;
          box-shadow: 0px -1px 0px 0px #f5f5f5 inset;
        }
        /deep/.van-field__body {
          height: 44px;
          .van-field__control:disabled {
            -webkit-text-fill-color: #323233 !important;
          }
        }
        // 上传区
        .upload-box {
          width: 104px;
          height: 104px;
          background: #f6f9ff;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          color: #677283;
          .van-icon {
            font-size: 28px;
            margin-bottom: 6px;
          }
          span {
            font-size: 12px;
          }
        }
        .upload-file {
          width: 104px;
          height: 104px;
          position: relative;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 4px;
          }
          .pdf-file {
            width: 100%;
            height: 100%;
            background: #f6f9ff;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            color: #677283;
            .van-icon {
              font-size: 28px;
              margin-bottom: 6px;
            }
          }
        }
        .id-card-area {
          display: flex;
          gap: 12px;
        }
      }
      .item-input-box-first {
        .title {
          margin: 0;
        }
      }
      .item-line {
        font-size: 13px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #333333;
        line-height: 18px;
        margin-bottom: 16px;
      }
    }
    .spacing {
      height: 8px;
      background: #f4f5f6;
    }
    .button-box {
      position: fixed;
      bottom: @safe-area;
      width: 100%;
      box-shadow: 0 -6px 10px 0 rgba(230, 234, 237, 0.3);
      padding: 10px 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: @WHITE;
      gap: 14px;
      .van-button {
        width: 48%;
        height: 44px;
        border-radius: 4px;
        font-size: 18px;
        flex: 1;
        font-weight: 500;
      }
    }
  }
</style>
